"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericAsync = exports.ASYNC_LOADING_STATUSES = void 0;
const mobx_1 = require("mobx");
var ASYNC_LOADING_STATUSES;
(function (ASYNC_LOADING_STATUSES) {
    ASYNC_LOADING_STATUSES[ASYNC_LOADING_STATUSES["IDLE"] = 0] = "IDLE";
    ASYNC_LOADING_STATUSES[ASYNC_LOADING_STATUSES["PENDING"] = 1] = "PENDING";
    ASYNC_LOADING_STATUSES[ASYNC_LOADING_STATUSES["SUCCEEDED"] = 2] = "SUCCEEDED";
    ASYNC_LOADING_STATUSES[ASYNC_LOADING_STATUSES["FAILED"] = 3] = "FAILED";
})(ASYNC_LOADING_STATUSES = exports.ASYNC_LOADING_STATUSES || (exports.ASYNC_LOADING_STATUSES = {}));
class GenericAsync {
    constructor() {
        this.status = ASYNC_LOADING_STATUSES.IDLE;
        this.data = null;
        mobx_1.makeObservable(this, {
            status: mobx_1.observable,
            data: mobx_1.observable,
            fetch: mobx_1.flow,
            pending: mobx_1.computed,
            idle: mobx_1.computed,
            successed: mobx_1.computed,
            failed: mobx_1.computed,
        }, { autoBind: true });
    }
    *fetch(props) {
        this.status = ASYNC_LOADING_STATUSES.PENDING;
        try {
            const data = yield this.fetchAction(props);
            this.data = data;
            this.status = ASYNC_LOADING_STATUSES.SUCCEEDED;
        }
        catch (e) {
            this.data = null;
            this.status = ASYNC_LOADING_STATUSES.FAILED;
        }
    }
    get pending() {
        return this.status === ASYNC_LOADING_STATUSES.PENDING;
    }
    get idle() {
        return this.status === ASYNC_LOADING_STATUSES.IDLE;
    }
    get successed() {
        return this.status === ASYNC_LOADING_STATUSES.SUCCEEDED;
    }
    get failed() {
        return this.status === ASYNC_LOADING_STATUSES.FAILED;
    }
    fetchAction(props) {
        throw new Error('fetchAction is not implemented.');
    }
    reset() {
        this.data = null;
        this.status = ASYNC_LOADING_STATUSES.IDLE;
    }
}
exports.GenericAsync = GenericAsync;
//# sourceMappingURL=async.js.map